import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssuesFieldAddRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-field-add',
	path: '/secure/admin/AddNewFieldScreen.jspa',
};
